<template>
    <div>        
        <!-- 상단 제목 -->
        <div class="topbanner">
            <h2>이용 내역</h2>
        </div>
        <!--// 상단 제목 -->
        <!-- 메인 컨텐츠 영역 -->
        <article class="main_contents">
            <!--div class="form-group history">
                <input type="date" name="date" class="form-control" title="시작일" v-model.trim="date_s" />
                <p>-</p>
                <input type="date" name="date" class="form-control" title="종료일" v-model.trim="date_e" />
                <button class="btn_common btn_mid" @click="loadHistory">기간 검색</button>
            </div-->
            <h6>최근 6개월간 이용하신 이용내역을 안내합니다.</h6>
            <div class="mainmsg" v-if="history_list.length==0">
                <span>조회된 이용 내역이 없습니다.</span>
            </div>
            <table class="table table-bordered result_table" v-if="history_list.length>0">
                <caption>이용 내역</caption>                
                <thead></thead>
                <tbody v-for="(address, index) in history_list" :key="index" v-show="index==view_index">
                    <tr>
                        <th scope="row">차량번호</th>
                        <td>{{address.no_drvid}}</td>
                    </tr>
                    <tr>
                        <th scope="row">신청일</th>
                        <td>{{address.receive_date | dateFormat}} {{address.receive_time}}</td>
                    </tr>
                    <tr>
                        <th scope="row">출발지</th>
                        <td>{{address.nm_fr}}</td>
                    </tr>
                    <tr>
                        <th scope="row">도착지</th>
                        <td>{{address.nm_to}}</td>
                    </tr>
                    <tr v-if="address.nm_via!=''">
                        <th scope="row">경유지</th>
                        <td>{{address.nm_via}}</td>
                    </tr>
                </tbody>
                <tfoot></tfoot>
            </table>
            <div class="form-group block_right" v-if="history_list.length>0">
                <button class="btn_common btn_short" @click="prevHistory" v-if="this.view_index>0">이전</button>
                <button class="btn_common btn_short" @click="nextHistory" v-if="this.view_index<(this.history_list.length-1)">다음</button>
            </div>
            <div class="history_bottom">
                <button class="btn_common" @click="main">메인으로 가기</button>
            </div>
        </article>
        <!--// 메인 컨텐츠 영역 -->
    </div>
</template>

<script>
import moment from 'moment';

export default {    
    data() {
        return {
            date_s: "",
            date_e: "",
            view_index: 0,
            history_list: []            
        }
    },
    mounted() {
        this.loadHistory();
    },
    filters: {
        dateFormat: function(value) {
            if(!value) return '';
            return moment(String(value)).format('YYYY.MM.DD');
        }
    },
    methods: {
        loadHistory() {            
            this.$http.get('/api/order/callList.do', {
                params: {
                    kind: this.CONSTANT.CALL_SEARCH_TYPE_HISTORY                    
                    /*date_s: this.date_s.replace(/[^0-9]/g, ""),
                    date_e: this.date_e.replace(/[^0-9]/g, "")*/
                }
            }).then((response) => {
                if(response.data.retval == this.CONSTANT.SUCCESS) {
                    if(this.date_s == "") {
                        this.date_s = moment(response.data.date_s).format('YYYY-MM-DD');
                    }

                    if(this.date_e == "") {
                        this.date_e = moment(response.data.date_e).format('YYYY-MM-DD');
                    }

                    this.history_list = response.data.list;
                } else {
                    if(response.data.retval == this.CONSTANT.LOGIN_ERROR) {
                        this.$store.commit("setSession", null);
                        this.$router.push({path: "/m/login", query: {return_url: "/m/order/history"}});                        
                    } else {
                        alert("이용내역 조회를 실패 하였습니다. [error_code:"+response.data.retval+"]");
                    }
                }
            });
        },
        prevHistory() {
            if(this.view_index > 0) {
                this.view_index--;
            }            
        },
        nextHistory() {
            if(this.view_index < (this.history_list.length-1)) {
                this.view_index++;
            }            
        },
        main() {
            this.$router.push("/m");
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/order/History.vue